import { sendPhoneVerification } from 'shared/api/v2/customers/customers.client';
import { formatPhoneNumber } from 'react-phone-number-input';
import { TVerificationModalError } from 'components/VerificationCodeModal/VerificationCodeModal';

export const triggerPhoneVerification = async (
    phoneNumber: string,
    merchantPhoneNumber: string | null,
    onOpenVerificationModal: (
        isOpen: boolean,
        errorMessage?: TVerificationModalError
    ) => void
): Promise<void> => {
    const response = await sendPhoneVerification(phoneNumber);
    if (response?.error === 'phone_number_has_unsubscribed') {
        const error: TVerificationModalError = {
            type: 'general',
            message:
                'Text START to {XXX} to resubscribe to messages at any time.',
        };
        if (merchantPhoneNumber) {
            error.message = error.message.replace(
                '{XXX}',
                formatPhoneNumber(merchantPhoneNumber) || merchantPhoneNumber
            );
        } else {
            error.type = 'merchant_phone';
            error.message =
                'Oops! Something went wrong with your verification code. Please try again.';
        }
        onOpenVerificationModal(true, error);
    } else if (response?.error === 'phone_verified_too_many_times') {
        onOpenVerificationModal(true, {
            type: 'verify_amount_exceeded',
            message:
                'Too many verification codes have been sent. Please wait 24 hours before requesting another code',
        });
    } else {
        onOpenVerificationModal(true);
    }
};
